import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { USE_API } from '../../config/env';
import { getContentAction } from '../../store/actions/contentActions';
import { Container } from '../layout/Primitives';
import { stripSeoRelFromInternalAnchors } from '../../utils/stripHtmlInternalAnchors';
import { useLanguage } from '../../contexts/LanguageContext';

export default function StoreContentPage({
  contentKey,
  title,
  fallback,
  maxWidth = '56rem',
  /** e.g. shop/client About: large light hero title */
  titleStyle,
  containerPadding = '3.5rem 1.5rem 4rem',
}) {
  const dispatch = useAppDispatch();
  const { locale } = useLanguage();
  const cacheKey = `${contentKey}_${locale}`;
  const { pages, loading } = useAppSelector((s) => s.content);
  const data = pages?.[cacheKey];
  const html = data?.content;

  useEffect(() => {
    if (!USE_API) return;
    dispatch(getContentAction(contentKey));
  }, [dispatch, contentKey, locale]);

  const safeHtml = useMemo(
    () => (html ? stripSeoRelFromInternalAnchors(html) : ''),
    [html],
  );

  return (
    <div className="animate-fade-in">
      <Container style={{ padding: containerPadding, maxWidth }}>
        {USE_API && loading && !data ? <p style={{ opacity: 0.7 }}>Loading…</p> : null}
        {USE_API && html ? (
          <>
            <h1
              className="font-display text-balance"
              style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)', ...titleStyle }}
            >
              {title}
            </h1>
            <div
              className="store-content-html"
              style={{ marginTop: '1rem' }}
              dangerouslySetInnerHTML={{ __html: safeHtml }}
            />
          </>
        ) : (
          fallback
        )}
      </Container>
    </div>
  );
}
